import { axios } from '@/api/request'

/**
 * api接口列表
 */
const api = {
  login:'/qywxLogin/',
  getsucais:'/teams/sucaifile/',
  getfenlei:'/teams/sucaicate/',
  add: '/teams/sucaifile/',
  getAuthorization:'/teams/getAuthorization/'
}

export function login (data) {
  return axios({
    url: api.login,
    method: 'post',
    data
  })
}

export function getsucais (params) {
  return axios({
    url: api.getsucais,
    method: 'get',
    params
  })
}
export function getfenlei (params) {
  return axios({
    url: api.getfenlei,
    method: 'get',
    params
  })
}
export function add (data) {
  return axios({
    url: api.add,
    method: 'post',
    data
  })
}
export function getAuthorization (params) {
  return axios({
    url: api.getAuthorization,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/views/sucaiview/sucaiupload/api.js